import React from 'react';
import content from '../../../../content/main.archie';
import Markdown from 'react-remarkable';
import {contentToText} from '../../../utils/helpers.jsx';
import FuelInset from '../FuelInset/FuelInset.jsx';

export default (props) => {
    return (<div className="container body-text">
        <div className="section">
            <div className="row">
                <div className="col l8">
                    <Markdown>
                        {contentToText(content['shipping-health-solutions1'],{})}
                    </Markdown>
                    <FuelInset />
                </div>
            </div>
        </div>
    </div>)   
}




// WEBPACK FOOTER //
// ./src/js/components/special/HealthSolutions/HealthSolutions.jsx